export default __webpack_public_path__ + "static/media/logoFooter.f3d8a87d.png";